import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { useUserOrganization } from "@/hooks/use-user-organization";

export function useDeviceChangeLog() {
  const { user } = useAuth();
  const { data: organizationId } = useUserOrganization();

  const logChange = async (deviceId: string, field: string, value: string) => {
    try {
      await (supabase as any).from("device_change_log").insert({
        device_id: deviceId,
        field,
        value,
        user_id: user?.id,
        organization_id: organizationId,
      });
    } catch (e) {
      console.warn("Failed to log device change:", e);
    }
  };

  return { logChange };
}
